const Card = ({ 
  children, 
  className = "",
  gradient = false,
  hover = false,
  ...props
}) => (
  <div 
    className={`
      bg-card rounded-lg border shadow-soft
      ${gradient ? 'bg-gradient-primary text-white' : ''}
      ${hover ? 'hover:shadow-strong transition-smooth' : ''}
      ${className}
    `}
    {...props}
  >
    {children}
  </div>
)

const CardHeader = ({ children, className = "" }) => (
  <div className={`p-6 ${className}`}>
    {children}
  </div>
)

const CardContent = ({ children, className = "" }) => (
  <div className={`p-6 pt-0 ${className}`}>
    {children}
  </div>
)

Card.Header = CardHeader
Card.Content = CardContent

export default Card